import { Theme } from '@mui/material';

import { customScrollbar } from '@minimalsTheme/shared/scrollbar';

export const sxMain = {
  bgcolor: 'background.default',
  px: { xs: 2, sm: 2, md: 5 },
  pt: { xs: 2, sm: 3, md: 11 },
  pb: { xs: 0, md: 11 },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flex: 1,
};

export const sxContainer = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  borderRadius: 2,
  backgroundColor: 'background.paper',
  maxWidth: 1200,
  width: '100%',
};

export const sxHeaderItem = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  p: 3,
  height: '100%',
  with: '100%'
};

export const sxSortRow = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  py: 5,
  maxWidth: 1200,
};

export const sxImageContainer = {
  maxWidth: 1200,
  backgroundColor: 'rgba(145, 158, 171, 0.04)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  minHeight: 'calc(100vh - 500px)',
  borderRadius: 2,
  border: '1px dashed rgba(145, 158, 171, 0.08)',
};

export const sxImageListContainer = (theme: Theme) => ({
  width: '100%',
  height: '100%',
  minHeight: '300px',
  ...customScrollbar(theme),
});

export const sxImagesCell = {
  display: 'flex',
  flexDirection: 'column',
  height: '226px',
  backgroundColor: 'background.paper',
  borderRadius: 1,
  cursor: 'pointer',
};

export const sxImage = {
  height: '176px',
  width: '100%',
  objectFit: 'cover',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
};

export const sxImageTitle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
